// extracted by mini-css-extract-plugin
export var active = "_tx-1";
export var circle = "_tx-0";
export var completed = "_tx-2";
export var connector = "_tx-4";
export var connectorCompleted = "_tx-7";
export var connectorSpacer = "_tx-5";
export var iconStrokeOverride = "_tx-8";
export var labelContainer = "_tx-6";
export var pending = "_tx-3";